import React from "react";
import "../../styles/Hero.css";
import background from "../../assets/background.svg";
import computer from "../../assets/computer.svg";
import poligono from "../../assets/poligono.svg";
import tact from "../../assets/tact.svg";
import HeroText from "./HeroText"

const Hero = () => {
  return (
    <section
      id="inicio"
      className="hero"
      style={{ backgroundImage: `url(${background})` }}
    >
      {/* Imagens posicionadas em absolute */}
      <img src={computer} alt="Computador" className="computer" />
      <img src={tact} alt="Logo Tact" className="logo-tact" />
      <img src={poligono} alt="Polígono decorativo" className="poligono" />

      {/* Texto central */}
    <div className="hero-text">
        <HeroText />
    </div>
    </section>
  );
};

export default Hero;
